// Shift-clicking selects a single consecutive list of items
// starting at the previous click.
const getClickedRange = (clickedId, displayedPartialTree, isShiftKeyPressed, previousCheckbox) => {
    const previousCheckboxIndex = displayedPartialTree.findIndex((item) => item.id === previousCheckbox);
    const newCheckboxIndex = displayedPartialTree.findIndex((item) => item.id === clickedId);
    if (previousCheckboxIndex !== -1 &&
        newCheckboxIndex !== -1 &&
        isShiftKeyPressed) {
        const clickedRange = displayedPartialTree.slice(Math.min(previousCheckboxIndex, newCheckboxIndex), Math.max(previousCheckboxIndex, newCheckboxIndex) + 1);
        return clickedRange.map((item) => item.id);
    }
    return [clickedId];
};
export default getClickedRange;
